import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from '../hook/useRouter';
import { ICollectionSubItem } from '../interface/ICollection';
import { RootState, store } from '../store';
import { replaceNum } from './CollectionItem';

export const CollectionItemSubItem = ({ sub, isActive }: { sub: ICollectionSubItem; isActive: boolean }) => {
    const { params, getValue, changeParam } = useRouter(['serverid']);
    const service = useSelector((state: RootState) => state.main.config.service);

    let pricetype = '';
    let priceTxt = '';

    if (isActive) {
        if (sub.unitPrice) {
            pricetype = 'tradeables';
            priceTxt = replaceNum(sub.unitPrice);
        } else {
            pricetype = 'none';
            priceTxt = '매물 없음';
        }
        if (!sub.tradable) {
            pricetype = 'tradedisable';
            priceTxt = '거래 불가';
        }
        if (sub.checked) {
            pricetype = '';
            priceTxt = '';
        }
    }

    return (
        <li>
            <button
                className={`btn-item ${sub.world && isActive ? 'is-worlditem' : ''}`}
                data-itemgrade={sub.grade}
                data-enchant={sub.enchantLevel}
                title={sub.enchantLevel > 0 ? '+' + sub.enchantLevel + ' ' + sub.itemName : sub.itemName}
                onClick={() => changeParam({ detail: `item_${sub.itemId}_${sub.enchantLevel}_${getValue('serverid')}` })}
            >
                <img
                    className="thumb"
                    src={sub.image}
                    onError={(e) => {
                        e.currentTarget.src = store.getState().main.config.wstatic + '/plaync/gameinfo/img/thumb-' + service + '.png';
                    }}
                />
                <span className="enchant">{sub.enchantLevel > 0 ? '+' + sub.enchantLevel : ''}</span>
                {sub.checked ? <span className="mine"></span> : ''}
                <span
                    className={`price col_${sub.itemId}_${sub.enchantLevel}`}
                    data-areas="컬렉션_리스트_아이템_클릭"
                    data-contents={sub.itemName}
                    data-pricetype={pricetype}
                >
                    {priceTxt}
                </span>
            </button>
        </li>
    );
};
